import { Typography, Box } from "@mui/material";
import React from "react";

const Header = ({ title, subtitle }) => {
  return (
    <Box>
      <Typography
        variant="h3"
        color="primary.800"
        fontWeight="bold"
        sx={{ mb: "6px", letterSpacing: "-0.04em" }}
      >
        {title}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {subtitle}
      </Typography>
    </Box>
  );
};

export default Header;
